import React from "react"
import { twMerge } from "tailwind-merge"

export default function InfoParagraph({ children, className }) {
  className = twMerge("text-sm text-gray-dark", className)
  return <p className={className}>{children}</p>
}
